import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import Analytics from "./pages/Analytics";
import ClientIntakeForms from "./pages/ClientIntakeForms";
import ContentCreator from "./pages/ContentCreator";
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Resumes from "./pages/Resumes";
import Settings from "./pages/Settings";
import Subscribers from "./pages/Subscribers";
import './styles/admin.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/subscribers" element={<Subscribers />} />
                <Route path="/resumes" element={<Resumes />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/content-creator" element={<ContentCreator />} />
                <Route path="/home" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/client-intake-forms" element={<ClientIntakeForms />} />
                <Route path="/client-intake" element={<ClientIntakeForms />} />
                <Route path="/content" element={<ContentCreator />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
